import { Alert, AlertProps } from "@mui/material";

export default function ErrorAlert({
  message,
  onClose,
  ...props
}: AlertProps & { message: string; onClose?: () => void }): JSX.Element {
  return (
    <Alert severity="error" onClose={onClose} {...props} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}
